import React from 'react';
import { Icon } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import __ from "lodash";
import LightTooltip from '../../../controls/LightTooltip';

const styles = (theme) => ({
  truckSeparator: {
    color:theme.palette.primary.secondary, 
    fontSize: 14,
    position: "relative",
    top: 2
  },
  separator: {
    display: "inline-block",
    paddingLeft: 10, 
    paddingRight: 10,
  },
  airport: {
    fontSize: 17,
    display: "inline-block"
  }
});

const BuildTruckRouteIconFromLegs = (props) => {
  const  classes = props.classes;
  const truckLegs = __.filter(props.legs, {transportType: 'TRUCK'});
  if (truckLegs.length < 1) return (<></>);
  return (
    <LightTooltip title={(
      <div style={{textAlign:"center"}}>
        <div style={{marginTop: -10}}><h3>Onward Trucking</h3></div>
        {
          truckLegs.map((leg, i) => (
            <div>
              <div className={classes.airport}>{leg.originAirportCode}</div><div className={classes.separator}><Icon className={classes.truckSeparator}>local_shipping</Icon></div><div className={classes.airport}>{leg.destinationAirportCode}</div>
            </div>
          ))
        }
      </div>
    )}>
      <Icon style={props.style}>local_shipping</Icon>
    </LightTooltip>
  )
}

export default withStyles(styles) (BuildTruckRouteIconFromLegs);